module.exports = "<div class=\"document-area\" ng-if=\"!$ctrl.base64 && !$ctrl.pdfUrl\">\n  <div class=\"loading\">\n    <h3>Cargando documento, por favor espere ...</h3>\n  </div>\n</div>\n<div class=\"pdfviewer\" ng-if=\"$ctrl.base64 || $ctrl.pdfUrl\">\n  <ng-pdf class=\"ng-pdf\" data=\"$ctrl.pdfUrl\" data64=\"$ctrl.base64\" style=\"height:100%\"\n  name=\"{{$ctrl.name}}\" scale=\"{{$ctrl.scale}}\" page=\"{{$ctrl.page}}\"\n  download=\"{{$ctrl.download}}\" print=\"{{$ctrl.print}}\" open=\"{{$ctrl.open}}\"></ng-pdf>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/core/vendor/pdf-viewer/pdf-viewer.html
// module id = 705
// module chunks = 0